import React, { useContext, useEffect } from 'react'
import { useDrag, useDrop } from 'react-dnd'
import { DRAGNDROP_TYPE } from '~/enums'
import TransitionAsset from './TransitionAsset'
import './LayerItem.scss'
import { DraggingItemContext } from '../DraggingItemProvider'

const DragTransitionContainer = props => {
  const { setHoveredTransitions } = useContext(DraggingItemContext)
  const { asset } = props

  const [{ isDragging }, drag ] = useDrag({
    canDrag: () => asset.draggable,
    item: {
      type: DRAGNDROP_TYPE.LAYER_TRANSITION_ASSET,
      transitionType: asset.type,
      id: asset.id,
      duration: asset.duration,
    },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  })

  const [{ isHovered, item }, drop ] = useDrop({
    accept: [
      DRAGNDROP_TYPE.MEDIA_ITEM,
      DRAGNDROP_TYPE.IMAGE_ITEM,
      DRAGNDROP_TYPE.TEXT_ITEM,
      DRAGNDROP_TYPE.AUDIO_ITEM,
      DRAGNDROP_TYPE.LAYER_ASSET,
      DRAGNDROP_TYPE.PREVIEW_MEDIA_ITEM,
    ],
    canDrop: () => false,
    collect: monitor => ({ isHovered: monitor.isOver(), item: monitor.getItem() }),
  })
  // ---
  useEffect(() => {
    if (asset?.id !== item?.id) {
      setHoveredTransitions({ itemId: asset.id, isHovered })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ isHovered, item ])

  return (
    <TransitionAsset {...props} connectDragSource={drag} drop={drop} isDragging={isDragging} />
  )
}

export default DragTransitionContainer
